import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './AdminApp';
import { ImageProvider } from "./context/ImageContext";

document.addEventListener('DOMContentLoaded', function () {
    const container = document.getElementById('image-hub-root');
    if (container) {
        const root = createRoot(container);
        root.render(
            <React.StrictMode>
                <ImageProvider>
                    <App />
                </ImageProvider>
            </React.StrictMode>
        );
    }
});
